import { isLineBank, isIknow99 } from 'config';
import { get } from 'lodash';
import { getAuth, getIknow99IsBinded, getLineBankIsBinded, getSkipLogin } from 'service/local-data-provider';

/**
 * @returns {'user' | 'register' | 'skip', 'none'}
 */

export const getLoginState = () => {
  const scopes = get(getAuth(), 'scopes', null);

  if (isLineBank) {
    return getLineBankIsBinded() ? 'user' : 'none';
  }

  if (isIknow99) {
    return getIknow99IsBinded() ? 'user' : 'none';
  }

  if (scopes) {
    switch (scopes) {
      case 'update_user_info':
        return 'register';
      default:
        return 'user';
    }
  } else {
    if (getSkipLogin()) {
      return 'skip';
    } else {
      return 'none';
    }
  }
};
